import { render, staticRenderFns } from "./RbacRoleEditDialog.vue?vue&type=template&id=44418ad6"
import script from "./RbacRoleEditDialog.vue?vue&type=script&lang=js"
export * from "./RbacRoleEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports